module.exports = __webpack_public_path__ + "img/ic_login_business.f28b4742.svg";